import { render, staticRenderFns } from "./LanguageSettings.vue?vue&type=template&id=978d33de&"
import script from "./LanguageSettings.vue?vue&type=script&lang=js&"
export * from "./LanguageSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports